import { render, staticRenderFns } from "./SettingPriority.vue?vue&type=template&id=6d200593"
import script from "./SettingPriority.vue?vue&type=script&lang=js"
export * from "./SettingPriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports